export class DashaMail {

    onLoadDetail(product) {
        if (typeof dashamail !== "undefined") {
            dashamail("async", {
                "operation": "ViewProduct",
                "data": {
                    "product": {
                        "productId": product.id,
                        "price": product.price
                    }
                }
            });
        }
    }

    onAddToCart(product) {
        if (typeof dashamail !== "undefined") {
            dashamail("cart.addProduct", {
                "productId": product.id,
                "quantity": product.quantity,
                "price": product.price
            });
        }
    }

    onRemoveFromCart(products) {
        if (typeof dashamail !== "undefined") {
            if (products) {
                products.map(product => {
                    dashamail("cart.removeProduct", {
                        "productId": product.id,
                        "quantity": 1
                    });
                });
            }
        }
    }
}

